import createSvgIcon from '@material-ui/core/utils/createSvgIcon';

const Saving = createSvgIcon(
    <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 25 20"
    fill="currentColor"
  >
    <path
      fillRule="evenodd"
      d="m19.83 7.5-2.27-2.27c.07-.42.18-.81.32-1.15.08-.18.12-.37.12-.58 0-.83-.67-1.5-1.5-1.5-1.64 0-3.09.79-4 2h-5C4.46 4 2 6.46 2 9.5S4.5 21 4.5 21H10v-2h2v2h5.5l1.68-5.59 2.82-.94V7.5h-2.17zM13 9H8V7h5v2zm3 2c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
      clipRule="evenodd"
    />
  </svg>,
  'Saving'
);

export default Saving;

